/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { validateYupSchema } from 'formik';
import { bankObject } from '../../components/investors/bankDetails';
//import { getDocumentDetails } from '../../components/investors/documentDetails';
import { contactPersonObject } from '../../components/NonIndividualInvestor/ContactDetails';
import { document_object } from '../../components/NonIndividualInvestor/DocumentDetails';
import { percentageError } from '../../components/NonIndividualInvestor/ubo';
import {
  accredidateValidationDate,
  applicantStatusMasters,
  APPLICATION_TYPE_FOR_DOCUMENTS,
  ckycFieldValidationDate,
  EDD_Validation_Date,
  investorTypeMasters,
  IS_PENNYDROP_APPLICABLE_FOR_AMC,
  maritalStatusMaster,
  npoValidationDate,
  occupationDetailsMasters,
  POA_Authorized_signatory_can_Esign_Enable,
  POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE,
  poaValidationDate,
  reTypeValidationDate,
  salutationsMasters,
  serviceValidationDate,
  USER_ROLES,
} from '../../utils/constant';
import { emailRegex, individualPanRegex } from '../../utils/regex';
import {
  bankDetailsSchema,
  contributorDetailsSchema,
  documentDetailsSchema,
  FATCAValidationSchema,
  KYCDetailsSchema,
  nomineeDetailsSchema,
  nonIndividualContactDetailsSchema,
  NonIndividualContributorValidationSchema,
  nonIndividualDocumentDetailsSchema,
} from '../../utils/schema';
import {
  checkIfApplicationIsIndividualPOA,
  checkIfApplicationIsNonIndividualPOA,
  checkValidationBasedOnDate,
  cleardpIdField,
  dlclIdFieldMandatory,
  getAddressData,
  getNomineeRelation,
  getRelation,
  isMinor,
  ifPushToXalt,
  isDprFieldApplicable,
  OthersOptionForRE,
  reTypeNAOption,
  getIsServiceRequired,
  shouldShowRBICategory,
} from '../../utils/utilityFunctions';
import { AuthorisedErrors, BankError, CALL_API, UboErrors } from '../middleware';

import {
  Applicant,
  ApplicationProps,
  Bank,
  NomineeType,
  Document,
  uboTypes,
  FetchUBORequestBody,
  StampPapersType,
  dashboardOnboardingType,
  monthwiseOnboardingSummaryType,
  distributorWisecommitmentType,
  monthwiseCommitmentAmountType,
  ubo,
  FatcaMdms,
  individuals_Poa_nonIndividuals_Documents,
  Groups,
  GroupSignatories,
  BrokerList,
  Broker,
} from '../types/api-types';
import {
  CreateApplicationRequestBody,
  CREATE_APPLICATION,
  CREATE_APPLICATION_SUCCESS,
  GET_APPLICATION,
  GET_APPLICATION_SUCCESS,
  GET_ALL_APPLICATION_SUCCESS,
  GET_STAMPPAPER_DETAILS_SUCCESS,
  GET_STAMPPAPER_DETAILS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS,
  GET_DISTRIBUTOR_COMMITMENTAMOUNT,
  GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS,
  GET_MONTHWISE_COMMITMENTAMOUNT,
  GET_ONBOARDING_SUMMARY_SUCCESS,
  GET_ONBOARDING_SUMMARY,
  GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS,
  GET_MONTHWISE_ONBOARDING_SUMMARY,
  GET_ALL_APPLICATION,
  UPDATE_APPLICATION_SUCCESS,
  UPDATE_APPLICATION,
  AddJointHolderRequestBody,
  ADD_APPLICANT_SUCCESS,
  ADD_APPLICANT,
  GetAllApplicantsRequestBody,
  GetAllApplicantionsResponseBody,
  PENNY_DROP_VERIFICATION_SUCCESS,
  PENNY_DROP_VERIFICATION,
  GET_Documents_SUCCESS,
  GET_Documents,
  GET_Ubo_SUCCESS,
  GET_Ubo,
  UBO_LISTING_SUCCESS,
  UBO_LISTING,
  GET_Fatca_SUCCESS,
  GET_Fatca,
  GET_BROKERS_SUCCESS,
  GET_BROKERS,
  GET_CONSOLIDATED_STAMPPAPER_DETAILS_SUCCESS,
  GET_CONSOLIDATED_STAMPPAPER_DETAILS,
} from '../types/application';
import { mdmsCountriesList, nationaliyType, togglerType } from '../types/mdms';

export const createApplication =
  (body: CreateApplicationRequestBody) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications`,
        method: 'POST',
        types: [CREATE_APPLICATION_SUCCESS, CREATE_APPLICATION],
        body,
      },
    });
  };

export const getApplicationDetails =
  (applicationId: string, method = '') =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/${applicationId}`,
        method: method ? 'DELETE' : 'GET',
        types: [GET_APPLICATION_SUCCESS, GET_APPLICATION],
      },
    });
  };
export const getParams = (paramsObj: Partial<GetAllApplicantsRequestBody>) => ({
  type: 'GET_PARAMS_DATA',
  paramsObj,
});
export const getAllApplications =
  (params: Partial<GetAllApplicantsRequestBody>) =>
  async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
    await dispatch(getParams(params));
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications`,
        method: 'GET',
        types: [GET_ALL_APPLICATION_SUCCESS, GET_ALL_APPLICATION],
        params: {
          limit: 10,
          sort: 'createdAt',
          order: 'DESC',
          ...params,
        },
      },
    });
  };

export const onboardingSummary =
  () =>
  async (dispatch: any): Promise<dashboardOnboardingType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/onboardingSummary`,
        method: 'GET',
        types: [GET_ONBOARDING_SUMMARY_SUCCESS, GET_ONBOARDING_SUMMARY],
      },
    });
  };

export const monthwiseOnboardingSummary =
  () =>
  async (dispatch: any): Promise<monthwiseOnboardingSummaryType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/monthwiseOnboardingSummary?months=4`,
        method: 'GET',
        types: [GET_MONTHWISE_ONBOARDING_SUMMARY_SUCCESS, GET_MONTHWISE_ONBOARDING_SUMMARY],
      },
    });
  };

export const distributorWisecommitmentAmount =
  () =>
  async (dispatch: any): Promise<distributorWisecommitmentType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/distributorWisecommitmentAmount`,
        method: 'GET',
        types: [GET_DISTRIBUTOR_COMMITMENTAMOUNT_SUCCESS, GET_DISTRIBUTOR_COMMITMENTAMOUNT],
      },
    });
  };

export const monthwiseCommitmentAmount =
  () =>
  async (dispatch: any): Promise<monthwiseCommitmentAmountType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/dashboard/monthwiseCommitmentAmount`,
        method: 'GET',
        types: [GET_MONTHWISE_COMMITMENTAMOUNT_SUCCESS, GET_MONTHWISE_COMMITMENTAMOUNT],
      },
    });
  };

// export const getStampPaperCount =
//   (params: Partial<GetAllApplicantsRequestBody>) =>
//   async (dispatch: any): Promise<GetAllApplicantionsResponseBody> => {
//     return await dispatch({
//       [CALL_API]: {
//         url: `/leegality/stampPaperDetails`,
//         method: 'GET',
//         types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],

//       },
//     });
//   };

export const getStampPaperCount =
  () =>
  async (dispatch: any): Promise<StampPapersType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/leegality/stampPaperDetails`,
        method: 'GET',
        types: [GET_STAMPPAPER_DETAILS_SUCCESS, GET_STAMPPAPER_DETAILS],
      },
    });
  };

export const getConsolidatedStampPaperCount =
  () =>
  async (dispatch: any): Promise<StampPapersType> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/leegality/consolidated-stampPaperDetails`,
        method: 'GET',
        types: [GET_CONSOLIDATED_STAMPPAPER_DETAILS_SUCCESS, GET_CONSOLIDATED_STAMPPAPER_DETAILS],
      },
    });
  };

export const updateApplication =
  ({
    body,
    applicationId,
    toastMessage,
  }: {
    body: Partial<ApplicationProps>;
    applicationId: string;
    toastMessage?: string;
  }) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    const showToast = typeof toastMessage !== 'undefined';
    if (showToast) {
      toastMessage =
        `Application ${body.applicationNumber || ''} - ` + (toastMessage || ' Saved successfully');
    }
    try {
      return await dispatch({
        [CALL_API]: {
          url: `/onboarding/applications/${applicationId}/update`,
          method: 'POST',
          types: [UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION],
          body,
          showToast,
          toastMessage,
        },
      });
    } catch (error: any) {
      console.log('catch error on update application', error);
      throw error;
    }
  };

export const addJointHolder =
  (body: AddJointHolderRequestBody, applicationId: string) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/applications/${applicationId}/addApplicant`,
        method: 'POST',
        types: [ADD_APPLICANT_SUCCESS, ADD_APPLICANT],
        body,
      },
    });
  };

export const validateContributorDetails = async (
  application: ApplicationProps | null,
  role: any,
  nationalitiesMdmsMasters: nationaliyType,
  ifXalt: boolean
) => {
  const {
    applicants = [] as Partial<Applicant>[],
    ppmNo = null,
    createdAt = '',
  } = application || {};
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      ...applicant,
      maritalStatus: applicant.maritalStatus
        ? Object.keys(maritalStatusMaster)?.includes(applicant.maritalStatus || '')
          ? applicant.maritalStatus
          : 'Other'
        : '',
      otherMaritalStatus: applicant.maritalStatus
        ? !Object.keys(maritalStatusMaster)?.includes(applicant.maritalStatus || '')
          ? applicant.maritalStatus
          : ''
        : '',
      nationality: applicant.nationality
        ? applicant.nationality.toUpperCase()
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        ? ''
        : 'INDIAN',
      namePrefix:
        applicant.namePrefix && salutationsMasters.includes(applicant.namePrefix || '')
          ? applicant.namePrefix
          : 'Mr.',
      jointApplicantRelation: ifXalt
        ? applicant.relationShipWithFirstApplicant
        : getRelation(applicant.relationShipWithFirstApplicant)
        ? applicant.relationShipWithFirstApplicant
        : 'Others',
      relationShipWithFirstApplicant: ifXalt
        ? ''
        : getRelation(applicant.relationShipWithFirstApplicant)
        ? ''
        : applicant.relationShipWithFirstApplicant,
    })),
    ppmNo,
    createdAt,
    nationalityDropdown: nationalitiesMdmsMasters.countries.map((list) => list.nationality),
  };
  try {
    await validateYupSchema(
      schemaData,
      contributorDetailsSchema(ifXalt, application?.createdAt || ''),
      true,
      schemaData
    );
  } catch (error) {
    throw `Contributor details`;
  }
};

export const validateKYCDetails = async (
  applicants: Partial<Applicant>[],
  role: any,
  brokerList: Broker[],
  createdDate: string
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => ({
      occupationDetails: applicant.occupationDetails || '',
      grossAnnualIncome: applicant.grossAnnualIncome || '',
      politicallyExposedPersonStatus: applicant.politicallyExposedPersonStatus
        ? applicant.politicallyExposedPersonStatus
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        ? ''
        : 'Not Applicable',
      ckycNo: applicant.ckycNo || '',
      tradingExperience: applicant.tradingExperience || '',
      dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
      sourceOfFunds: applicant.sourceOfFunds || '',
      sourceOfFundsOthers: applicant.sourceOfFundsOthers || '',
      dpId: applicant.dpId || '',
      clId: applicant.clId || '',
      nameOfBroker: applicant.nameOfBroker || '',
    })),
  };
  try {
    await validateYupSchema(
      schemaData,
      KYCDetailsSchema(brokerList as Broker[], createdDate || ''),
      true,
      schemaData
    );
  } catch (error) {
    throw `KYC details`;
  }
};

export const validateFATCA = async (
  applicants: Partial<Applicant>[],
  role: any,
  nationalitiesMdmsMasters: nationaliyType
) => {
  const schemaData = {
    applicants: applicants?.map((applicant) => ({
      typeOfAddressProvidedAtKRA: applicant.typeOfAddressProvidedAtKRA || '',
      taxResidentOfAnyCountryOtherThanIndia:
        applicant.taxResidentOfAnyCountryOtherThanIndia || false,
      placeOfBirth: applicant.placeOfBirth || '',
      countryOfBirth: applicant.countryOfBirth
        ? applicant.countryOfBirth.toUpperCase()
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        ? ''
        : 'INDIA',
      countryOfNationality: applicant.countryOfNationality
        ? applicant.countryOfNationality.toUpperCase()
        : [USER_ROLES.INVESTOR, USER_ROLES.POAAPPROVER].includes(role)
        ? ''
        : 'INDIA',
      taxCountryName: applicant.taxCountryName || '',
      taxID: applicant.taxID || '',
      idType: applicant.idType || '',
      nameOfEntity: applicant.nameOfEntity || '',
      dateOfIncorporation: applicant.dateOfIncorporation || '',
      cityOfIncorporation: applicant.cityOfIncorporation || '',
      countryOfIncorporation: applicant.countryOfIncorporation || '',
      entityExcemptionCode: applicant.entityExcemptionCode || '',
    })),
    countryDropdown: nationalitiesMdmsMasters.countries.map((list) => list.name),
  };
  try {
    await validateYupSchema(schemaData, FATCAValidationSchema, true, schemaData);
  } catch (error) {
    throw `FATCA`;
  }
};

export const validateNomineeDetails = async (
  Nominees: Partial<NomineeType>[],
  doNotWishToNominate: boolean,
  applicants: Partial<Applicant>[],
  ifXalt: boolean,
  createdAt: string,
  toggler: togglerType
) => {
  if (
    !checkValidationBasedOnDate(
      createdAt || '',
      toggler?.dateFeatureToggles?.nomineeRemovalAndDeclarationValidationDate || ''
    )
  ) {
    const schemaData = {
      doNotWishToNominate: doNotWishToNominate === null ? true : doNotWishToNominate,
      nominees: Nominees.length
        ? Nominees.map((nominee) => ({
            ...nominee,
            Relationship: ifXalt
              ? nominee.nomineeRelationship
              : getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
              ? nominee.nomineeRelationship
                ? nominee.nomineeRelationship.toUpperCase()
                : nominee.nomineeRelationship
              : 'OTHERS',
            nomineeRelationship: ifXalt
              ? ''
              : getNomineeRelation(nominee.nomineeRelationship?.toUpperCase())
              ? ''
              : nominee.nomineeRelationship,
          }))
        : [],
    };
    try {
      await validateYupSchema(
        schemaData,
        nomineeDetailsSchema(applicants, ifXalt),
        true,
        schemaData
      );
    } catch (error) {
      throw `Nominee details`;
    }
  }
  return;
};

export const validateBankDetails = async (
  bankDetails: Partial<Bank>[],
  verifyPennydrop: boolean,
  applicationType: string,
  applicants: Partial<Applicant>[]
) => {
  const schemaData = {
    applicationType: applicationType,
    status: applicants.length ? applicants[0].status : '',
    banks: bankDetails.length
      ? bankDetails.map((bank) => ({ ...bank, defaultBankAccount: !!bank.defaultBankAccount }))
      : [bankObject],
  };
  try {
    if (IS_PENNYDROP_APPLICABLE_FOR_AMC && verifyPennydrop) {
      const isAllBanksPennyChecked = bankDetails.every((bank) => bank.pennydropCheck);
      if (!isAllBanksPennyChecked) {
        throw new BankError('Please make sure that all the banks are verified');
      }
    }
    await validateYupSchema(schemaData, bankDetailsSchema(applicants), true, schemaData);
  } catch (error) {
    if (error instanceof BankError) {
      throw error;
    }
    throw `Bank details`;
  }
};

export const validateDocuments = async (
  applicants: Partial<Applicant>[],
  hasPOA: boolean,
  documentsData: Document,
  Nominees: Partial<NomineeType>[],
  role: string,
  createdAt: string,
  isAccreditedInvestor: boolean
) => {
  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {
      let docData = '';
      if (
        !hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL;
      }
      if (
        hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.Individual
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.INDIVIDUAL_POA;
      }
      if (
        !hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI;
      }
      if (
        hasPOA &&
        applicantStatusMasters[applicant.status as string] === applicantStatusMasters.NRI
      ) {
        docData = APPLICATION_TYPE_FOR_DOCUMENTS.NRI_POA;
      }
      return {
        documents:
          typeof documentsData !== 'undefined'
            ? ((documentsData as Document)[docData] || [])
                .filter((doc) => {
                  if (
                    hasPOA &&
                    applicant.applicant_type !== '1' &&
                    doc.documentType === 'poaNotarized'
                  ) {
                    return;
                  }
                  if (
                    checkValidationBasedOnDate(createdAt || '', EDD_Validation_Date) &&
                    doc.documentType === 'enhanced_due_diligence'
                  ) {
                    return;
                  }
                  if (
                    !isAccreditedInvestor &&
                    !checkValidationBasedOnDate(createdAt || '', accredidateValidationDate) &&
                    doc.documentType === 'accreditation_certificate'
                  ) {
                    return;
                  }
                  return doc;
                })
                .filter((ele) => ele)
                .map((_doc) => {
                  if (role === USER_ROLES.POAAPPROVER && _doc.documentType === 'poaNotarized') {
                    return { ..._doc, required: 'true' };
                  }
                  if (
                    isAccreditedInvestor &&
                    checkValidationBasedOnDate(createdAt || '', accredidateValidationDate) &&
                    _doc.documentType === 'accreditation_certificate'
                  ) {
                    return { ..._doc, required: 'true' };
                  }
                  return _doc;
                })
                .filter((document) => {
                  if (applicant.amlCheck && document.documentType === 'compliance_document') {
                    return;
                  }
                  return document;
                })
                .filter((ele) => ele)
                .filter((doc) => {
                  return doc;
                })
                .filter((ele) => ele)
                .map((doc) => {
                  return doc;
                })
                .map((_doc) => {
                  return _doc;
                })
                .map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                  const {
                    documentType,
                    documentName,
                    multipleFiles,
                    required,
                    options,
                    downloadTemplate,
                  } = doc;
                  const { documents: existingDocuments = [] } = applicant || {};
                  const docsOfCurrentDocType = existingDocuments
                    .filter((doc) => doc.documentType === documentType)
                    .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                  return {
                    documentType: documentType,
                    documentName: documentName,
                    documentsList: docsOfCurrentDocType.length
                      ? docsOfCurrentDocType.map((doc, ind) => {
                          const {
                            id,
                            documentName = '',
                            documentType = '',
                            documentId = '',
                            isActive = true,
                            file = undefined,
                          } = doc;
                          return {
                            id,
                            applicantId: applicant?.id,
                            documentType,
                            documentName,
                            documentId,
                            isActive,
                            file,
                            options,
                            required,
                            downloadTemplate,
                            uniqueKey: (applicant_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              ind.toString()) as string,
                            errorOnUpload: document_object.errorOnUpload,
                          };
                        })
                      : [
                          {
                            documentType,
                            documentName,
                            required,
                            options,
                            downloadTemplate,
                            uniqueKey: (applicant_index.toString() +
                              '-' +
                              index.toString() +
                              '-' +
                              '0') as string,
                            ...document_object,
                          },
                        ],
                    required,
                    multipleFiles,
                    options,
                    downloadTemplate,
                  };
                })
            : [],
      };
    }),
    nominees: Nominees.map((nominee, nominee_index) => {
      return {
        nomineedocuments:
          typeof documentsData !== 'undefined'
            ? (isMinor(nominee.dateOfBirth || '')
                ? [
                    ...((documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] ||
                      []),
                    ...((documentsData as Document)[
                      APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_GUARDIAN
                    ] || []),
                  ].map((doc) => {
                    return doc;
                  })
                : (documentsData as Document)[APPLICATION_TYPE_FOR_DOCUMENTS.NOMINEE_DOC] || []
              ).map((doc: individuals_Poa_nonIndividuals_Documents, index: number) => {
                const { documentType, documentName, multipleFiles, required, options } = doc;
                const { nomineedocuments: existingDocuments = [] } = nominee || {};
                const docsOfCurrentDocType = existingDocuments
                  .filter((doc) => doc.documentType === documentType)
                  .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
                return {
                  documentType: documentType,
                  documentName: documentName,
                  documentsList: docsOfCurrentDocType.length
                    ? docsOfCurrentDocType.map((doc, ind) => {
                        const {
                          documentName = '',
                          documentType = '',
                          documentId = '',
                          isActive = true,
                          file = undefined,
                        } = doc;
                        return {
                          documentType,
                          documentName,
                          documentId,
                          isActive,
                          file,
                          options,
                          required,
                          uniqueKey: (nominee_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            ind.toString()) as string,
                        };
                      })
                    : [
                        {
                          documentType,
                          documentName,
                          required,
                          options,
                          uniqueKey: (nominee_index.toString() +
                            '-' +
                            index.toString() +
                            '-' +
                            '0') as string,
                          ...document_object,
                        },
                      ],
                  required,
                  multipleFiles,
                  options,
                };
              })
            : [],
      };
    }),
  };
  try {
    await validateYupSchema(schemaData, documentDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};

export const isFormValidForSubmission = async (
  application: ApplicationProps | null,
  validateDoc = true,
  verifyPennydrop = true,
  nationalitiesMdmsMasters = {},
  brokerList: Broker[] = [],
  toggler: togglerType,
  documentsResponse = {},
  role = ''
) => {
  const {
    applicants = [],
    nominees = [],
    doNotWishToNominate = false,
    banks = [],
    hasPOA = true,
    applicationType = '',
    createdAt = '',
  } = application || {};

  try {
    application?.hasPOA &&
      (await validatePOAAuthorizedSignatories(
        application
        // toggler?.dateFeatureToggles?.poaValidationDate || ''
      ));
    await validateContributorDetails(
      application,
      role,
      nationalitiesMdmsMasters as nationaliyType,
      ifPushToXalt(application?.pushDataTo || '')
    );
    await validateKYCDetails(applicants, role, brokerList, application?.createdAt as string);
    await validateFATCA(applicants, role, nationalitiesMdmsMasters as nationaliyType);
    await validateNomineeDetails(
      nominees,
      doNotWishToNominate,
      applicants,
      ifPushToXalt(application?.pushDataTo || ''),
      createdAt,
      toggler
    );
    await validateBankDetails(banks, verifyPennydrop, applicationType, applicants);
    validateDoc &&
      Object.keys(documentsResponse).length !== 0 &&
      (await validateDocuments(
        applicants,
        hasPOA,
        documentsResponse as Document,
        nominees,
        role,
        application?.createdAt || '',
        application?.isAccreditedInvestor || false
      ));
  } catch (error) {
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};

export const pennyDropVerification =
  (body: Bank) =>
  async (dispatch: any): Promise<Bank> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/pennydropverification`,
        method: 'POST',
        types: [PENNY_DROP_VERIFICATION_SUCCESS, PENNY_DROP_VERIFICATION],
        body,
      },
    });
  };

export const getDocuments =
  () =>
  async (dispatch: any): Promise<Document> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/required_document_master.json',
        method: 'GET',
        types: [GET_Documents_SUCCESS, GET_Documents],
      },
    });
  };

export const getBrokers =
  () =>
  async (dispatch: any): Promise<BrokerList> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/registered_broker_list.json',
        method: 'GET',
        types: [GET_BROKERS_SUCCESS, GET_BROKERS],
      },
    });
  };

export const getUboTypes =
  () =>
  async (dispatch: any): Promise<uboTypes> => {
    return await dispatch({
      [CALL_API]: {
        url: '/mdms/uboTypeMaster.json',
        method: 'GET',
        types: [GET_Ubo_SUCCESS, GET_Ubo],
      },
    });
  };

export const FetchData =
  (body: FetchUBORequestBody) =>
  async (dispatch: any): Promise<ubo> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/kradetails`,
        method: 'POST',
        types: [UBO_LISTING_SUCCESS, UBO_LISTING],
        body,
      },
    });
  };

export const FatcaMdmsData =
  (param: boolean) =>
  async (dispatch: any): Promise<FatcaMdms> => {
    return await dispatch({
      [CALL_API]: {
        url: `/mdms/${param ? 'fatca_data2' : 'fatca_data'}.json`,
        method: 'GET',
        types: [GET_Fatca_SUCCESS, GET_Fatca],
      },
    });
  };

export const validateNonIndividualContributorDetails = async (
  application: ApplicationProps | null,
  brokerList: Broker[],
  pushDataTo: string
) => {
  const { applicants = [], createdAt: createdDate = '', ppmNo = null } = application || {};
  const schemaData = {
    ppmNo,
    applicants: applicants.map((applicant) => {
      const isServicesRequired = getIsServiceRequired(applicant);
      return {
        ...applicant,
        dlclId: applicant.dlclId ? applicant.dlclId : dlclIdFieldMandatory() ? '' : 'none',
        nameOfBroker: applicant.nameOfBroker || '',
        sourceOfFunds: applicant.sourceOfFunds || '',
        sourceOfFundsOthers: applicant.sourceOfFundsOthers || '',
        isTrustEntity:
          investorTypeMasters[applicant.investorType || ''] === investorTypeMasters.trust &&
          checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
            ? applicant.isTrustEntity
            : '',
        darpanRegistrationNo:
          isDprFieldApplicable(applicant.investorType || '', applicant.isTrustEntity || '') &&
          applicant.isNpo &&
          checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
            ? applicant.darpanRegistrationNo
            : '',
        isNpo:
          isDprFieldApplicable(applicant.investorType || '', applicant.isTrustEntity || '') &&
          checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
            ? applicant.isNpo
            : false,
        isNotNpo:
          isDprFieldApplicable(applicant.investorType || '', applicant.isTrustEntity || '') &&
          checkValidationBasedOnDate(application?.createdAt || '', npoValidationDate)
            ? applicant.isNotNpo
            : false,
        reType:
          checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
          shouldShowRBICategory(applicant.rbiRegulatedEntity || '')
            ? applicant?.reType || ''
            : '',
        reTypeOthers: OthersOptionForRE(applicant.reType || '') ? applicant.reTypeOthers || '' : '',
        RBIRegNo:
          checkValidationBasedOnDate(application?.createdAt || '', reTypeValidationDate) &&
          shouldShowRBICategory(applicant.rbiRegulatedEntity || '') &&
          applicant.reType
            ? applicant.RBIRegNo || ''
            : '',
        isServicesRequired: checkValidationBasedOnDate(
          application?.createdAt || '',
          serviceValidationDate
        )
          ? isServicesRequired
          : [],
        rbiRegulatedEntity: checkValidationBasedOnDate(
          application?.createdAt || '',
          reTypeValidationDate
        )
          ? applicant.rbiRegulatedEntity
          : '',
      };
    }),
  };
  try {
    await validateYupSchema(
      schemaData,
      NonIndividualContributorValidationSchema(
        brokerList as Broker[],
        //createdDate || '',
        application?.createdAt || '',
        ifPushToXalt(pushDataTo)
      ),
      true,
      schemaData
    );
  } catch (error) {
    throw `Contributor details`;
  }
};
export const validateNonIndividualContactDetails = async (
  applicants: Partial<Applicant>[],
  countryDropdown: string[]
) => {
  const schemaData = {
    applicants: applicants.map((applicant) => {
      const correspondence = getAddressData('correspondence', applicant.addresses);
      const permanent = getAddressData('permanent', applicant.addresses);
      const defaultPayload = {
        contactperson: applicant.contactperson
          ? {
              ...applicant.contactperson,
              countryNameAndCode: applicant.contactperson.countryNameAndCode
                ? applicant.contactperson.countryNameAndCode
                : 'India: +91',
              country: applicant.contactperson.country
                ? applicant.contactperson.country.toUpperCase()
                : 'INDIA',
            }
          : contactPersonObject,
        address: {
          correspondence,
        },
      };
      const permanentAddressPayload = correspondence.permanentAddressSameAsCorresponding
        ? defaultPayload
        : {
            ...defaultPayload,
            address: {
              ...defaultPayload.address,
              permanent: {
                ...permanent,
                country: permanent.country ? permanent.country.toUpperCase() : 'INDIA',
              },
              correspondence: {
                ...correspondence,
                country: correspondence.country ? correspondence.country.toUpperCase() : 'INDIA',
              },
            },
          };
      return permanentAddressPayload;
    }),
    countryDropdown: countryDropdown,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualContactDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Contact details`;
  }
};

export const validateNonIndividualDocumentDetails = async (
  applicants: Partial<Applicant>[],
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  banks: Partial<Bank>[],
  createdAt: string,
  isAccreditedInvestor: boolean
) => {
  const schemaData = {
    applicants: applicants.map((applicant, applicant_index) => {
      return {
        documents: documentsData
          .filter((document) => {
            if (applicant.amlCheck && document.documentType === 'compliance_document') {
              return;
            }
            if (
              checkValidationBasedOnDate(createdAt || '', EDD_Validation_Date) &&
              document.documentType === 'enhanced_due_diligence'
            ) {
              return;
            }
            if (
              checkValidationBasedOnDate(createdAt || '', npoValidationDate) &&
              document.documentType === 'npo_declaration'
            ) {
              return;
            }
            if (
              !isAccreditedInvestor &&
              !checkValidationBasedOnDate(createdAt || '', accredidateValidationDate) &&
              document.documentType === 'accreditation_certificate'
            ) {
              return;
            }
            return document;
          })
          .filter((ele) => ele)
          //.map((doc) => ({ ...doc, required: 'true' }))
          .map((_doc) => {
            if (
              isAccreditedInvestor &&
              checkValidationBasedOnDate(createdAt || '', accredidateValidationDate) &&
              _doc.documentType === 'accreditation_certificate'
            ) {
              return { ..._doc, required: 'true' };
            }
            if (
              !checkValidationBasedOnDate(createdAt || '', npoValidationDate) &&
              _doc.documentType === 'npo_declaration'
            ) {
              return { ..._doc, required: 'true' };
            }
            return _doc;
          })
          .map((doc, index) => {
            const { documentType, documentName, multipleFiles, required, options } = doc;
            const { documents: existingDocuments = [] } = applicant || {};
            const docsOfCurrentDocType = existingDocuments
              .filter((doc) => doc.documentType === documentType)
              .sort((doc1, doc2) => Number(doc1.documentId) - Number(doc2.documentId));
            return {
              documentType: documentType,
              documentName: documentName,
              documentsList: docsOfCurrentDocType.length
                ? docsOfCurrentDocType.map((doc, ind) => {
                    const {
                      documentName = '',
                      documentType = '',
                      documentId = '',
                      isActive = true,
                      file = undefined,
                    } = doc;
                    return {
                      documentType,
                      documentName,
                      documentId,
                      isActive,
                      file,
                      options,
                      required,
                      uniqueKey: (applicant_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        ind.toString()) as string,
                    };
                  })
                : [
                    {
                      documentType,
                      documentName,
                      required,
                      options,
                      uniqueKey: (applicant_index.toString() +
                        '-' +
                        index.toString() +
                        '-' +
                        '0') as string,
                      ...document_object,
                    },
                  ],
              required,
              multipleFiles,
              options,
            };
          }),
      };
    }),
    banks: banks,
  };
  try {
    await validateYupSchema(schemaData, nonIndividualDocumentDetailsSchema, true, schemaData);
  } catch (error) {
    throw `Document details`;
  }
};
const fieldsTocheckForAuthorisedSignatories = [
  {
    key: 'name',
    label: 'Name',
    validateMulitple: false,
  },
  {
    key: 'pan',
    label: 'PAN',
    validateMulitple: true,
    regex: individualPanRegex,
    regexMsg: 'Only Individual PANs are allowed',
  },
  { key: 'mobile', label: 'Mobile Number', validateMulitple: true },
  {
    key: 'email',
    label: 'Email ID',
    validateMulitple: true,
    regex: emailRegex,
  },
  {
    key: 'designation',
    label: 'Designation',
    validateMulitple: false,
  },
];

export const validateNonIndividualAuthorisedSignatories = async (groups: Groups[]) => {
  try {
    groups.map((group) => {
      const getActiveSignatories = group.groupsignatories.filter((item) => item.isActive);
      const getCanEsignCount = getActiveSignatories.filter((item) => item.canEsign);
      if (!getActiveSignatories.length) {
        throw new AuthorisedErrors('Please add Authorised Signatories');
      }
      if (!getCanEsignCount.length) {
        throw new AuthorisedErrors('Please Select a member for E-Sign in Authorised Signatories');
      }
      if (getCanEsignCount.length < group.threshold) {
        throw new AuthorisedErrors(
          'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories'
        );
      }
      getActiveSignatories.forEach((signatory, index) => {
        fieldsTocheckForAuthorisedSignatories.forEach((field) => {
          if (!signatory[field.key as keyof GroupSignatories] as unknown as string) {
            throw new AuthorisedErrors(`${field.label} is required for signatory ${index + 1}`);
          }
          if (
            field.regex &&
            !field.regex.test(signatory[field.key as keyof GroupSignatories] as unknown as string)
          ) {
            throw new AuthorisedErrors(
              field.regexMsg
                ? `${field.regexMsg} for signatory ${index + 1}`
                : `Please enter valid ${field.label} for signatory ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = getActiveSignatories.filter(
              (vsignatory) =>
                (vsignatory[field.key as keyof GroupSignatories] as unknown as string) ===
                (signatory[field.key as keyof GroupSignatories] as unknown as string)
            );
            if (values.length > 1) {
              throw new AuthorisedErrors(
                `There is already same ${field.label} for an Authorised Signatory associated with this application`
              );
            }
          }
        });
      });
      return group;
    });
  } catch (error) {
    if (error instanceof AuthorisedErrors) {
      throw error;
    }
  }
};

const fieldsTocheckForUbos = [
  {
    key: 'panNumber',
    label: 'Taxpayer ID Number/PAN/Equivalent ID Number',
    validateMulitple: true,
    required: true,
  },
  {
    key: 'dob',
    label: 'Date of Birth',
    validateMulitple: false,
    required: true,
  },
  { key: 'name', label: 'Name of UBO', validateMulitple: false, required: true },
  {
    key: 'identificationType',
    label: 'Identification Type',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'percentageOfBeneficialInterest',
    label: 'Percentage of beneficial interest',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'countryOfTaxResidency',
    label: 'Country of Tax Residency',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'cpUboCode',
    label: 'CP/UBO Code',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'placeAndCountryOfBirth',
    label: 'Place & Country of Birth',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'occupation',
    label: 'Occupation',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'gender',
    label: 'Gender',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'nationality',
    label: 'Nationality',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'fatherName',
    label: 'Father Name',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'ckycNumber',
    label: 'CKYC Number',
    validateMulitple: true,
    required: false,
  },
  {
    key: 'address2',
    label: 'Address 1',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'address3',
    label: 'Address 2',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'pincode',
    label: 'Pincode',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'city',
    label: 'City',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'state',
    label: 'State',
    validateMulitple: false,
    required: true,
  },
  {
    key: 'country',
    label: 'Country',
    validateMulitple: false,
    required: true,
  },
];
const validateNonIndividualUbo = async (
  applicants: Partial<Applicant>[],
  ubo_declaration_type: string,
  ubo_declaration_value: string,
  ubos: ubo[],
  nationalityDropdown: string[],
  countryDropdown: string[],
  createdAt: string
) => {
  try {
    // const applicantsCkycNumbers = applicants?.map((applicant) => applicant.ckycNo);
    if (!ubo_declaration_type) {
      throw new UboErrors('Please Select Declaration Type in Declaration of Ubo');
    }
    if (!ubo_declaration_value) {
      throw new UboErrors('Please Select Declaration value in Declaration of Ubo');
    }
    if (ubo_declaration_type === 'none' && !ubos.filter((_item) => _item.isActive).length) {
      throw new UboErrors('Please Add Ultimate Benificiary Owners(UBO)');
    }
    if (ubos.filter((_item) => _item.isActive).length) {
      const activeUbos = ubos.filter((_item) => _item.isActive);
      activeUbos.map((ubo) => {
        if (!ubo.ckycNumber && checkValidationBasedOnDate(createdAt, ckycFieldValidationDate)) {
          throw new UboErrors(`CKYC Number of ${ubo.name} should be required`);
        }
        // if (ubo.ckycNumber && applicantsCkycNumbers.includes(ubo.ckycNumber)) {
        //   throw new UboErrors(
        //     `CKYC Number of ${ubo.name} should not be same as CKYC Number exist in Contributor Details`
        //   );
        // }
        if (!nationalityDropdown.includes(ubo.nationality || '')) {
          throw new UboErrors(`Invalid Nationality for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.country || '')) {
          throw new UboErrors(`Invalid Country for ${ubo.name} in Declaration of Ubo`);
        }
        if (!countryDropdown.includes(ubo.countryOfTaxResidency || '')) {
          throw new UboErrors(
            `Invalid Country of Tax Residency for ${ubo.name} in Declaration of Ubo`
          );
        }
        if (!occupationDetailsMasters.includes(ubo.occupation || '')) {
          throw new UboErrors(`Invalid Occupation for ${ubo.name} in Declaration of Ubo`);
        }
      });
      percentageError(ubos, true);
    }
    ubos
      .filter((_item) => _item.isActive)
      .forEach((ubo, index) => {
        fieldsTocheckForUbos.forEach((field) => {
          if ((!ubo[field.key as keyof ubo] as unknown as string) && field.required) {
            throw new UboErrors(`${field.label} is required for ubo ${index + 1}`);
          }
          if (
            field.key === 'dob' &&
            (ubo[field.key as keyof ubo] as unknown as string) &&
            isMinor(field.key)
          ) {
            throw new UboErrors(`Age should be greater than 18 for ubo ${index + 1}`);
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof ubo] as unknown as number) <= 0
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest should be greater 0 for ubo ${index + 1}`
            );
          }
          if (
            field.key === 'percentageOfBeneficialInterest' &&
            (ubo[field.key as keyof ubo] as unknown as number) > 100
          ) {
            throw new UboErrors(
              `Percentage Of Beneficial Interest must not exceed 100% for ubo ${index + 1}`
            );
          }
          if (field.validateMulitple) {
            const values = ubos.filter(
              (_ubo) =>
                (_ubo[field.key as keyof ubo] as unknown as string) ===
                  (ubo[field.key as keyof ubo] as unknown as string) &&
                (ubo[field.key as keyof ubo] as unknown as string) &&
                (_ubo[field.key as keyof ubo] as unknown as string)
            );
            if (values.length > 1) {
              throw new UboErrors(
                `There is already same ${field.label} for an Ubos associated with this application`
              );
            }
          }
        });
      });
  } catch (e) {
    if (e instanceof UboErrors) {
      throw e;
    }
  }
};

export const validatePOAAuthorizedSignatories = async (
  application: ApplicationProps | null
  // poaValidationDate: string
) => {
  const { poaauthorisedsignatories: authorisedSignatoriesPOA = [] } = application || {};
  try {
    if (
      checkValidationBasedOnDate(application?.createdAt || '', poaValidationDate) &&
      checkIfApplicationIsNonIndividualPOA(application as ApplicationProps) &&
      POA_Authorized_signatory_can_Esign_Enable &&
      ((checkIfApplicationIsIndividualPOA(application as ApplicationProps) &&
        POA_AUTHORIZED_SIGNATORY_INDIVIDUAL_FLOW_VISIBLITY_ENABLE) ||
        checkIfApplicationIsNonIndividualPOA(application as ApplicationProps))
    ) {
      const getCanEsignCount = authorisedSignatoriesPOA?.filter((item) => item.canEsign);
      if (!authorisedSignatoriesPOA?.length) {
        throw new AuthorisedErrors('Please add Authorised Signatories');
      }
      if (!getCanEsignCount.length) {
        throw new AuthorisedErrors('Please Select a member for E-Sign');
      }
      if (getCanEsignCount.length < Number(application?.requiredAuthorisedSignatory || 0)) {
        throw new AuthorisedErrors(
          'Authorised Signatories that can esign can not be less than the Total No. of required Authorised Signatories'
        );
      }
    }
  } catch (error) {
    if (error instanceof AuthorisedErrors) {
      throw error;
    }
  }
};

export const nonIndividualFormValidForSubmission = async (
  application: ApplicationProps | null,
  documentsData: individuals_Poa_nonIndividuals_Documents[],
  mdmsCountriesList: mdmsCountriesList[],
  brokerList: Broker[],
  verifyPennydrop = true,
  role = ''
) => {
  const {
    applicants = [],
    banks = [],
    groups = [],
    ubo_declaration_type = '',
    ubo_declaration_value = '',
    ubos = [],
    applicationType = '',
    createdAt = '',
  } = application || {};
  const nationalityDropdown = mdmsCountriesList.map((list) => list.nationality);
  const countryDropdown = mdmsCountriesList.map((list) => list.name);
  try {
    await validateNonIndividualContributorDetails(
      application,
      brokerList as Broker[],
      application?.pushDataTo || ''
    );
    await validateNonIndividualContactDetails(applicants, countryDropdown);
    await validateBankDetails(banks, verifyPennydrop, applicationType, applicants);
    await validateNonIndividualDocumentDetails(
      applicants,
      documentsData,
      banks,
      application?.createdAt || '',
      application?.isAccreditedInvestor || false
    );
    {
      !application?.hasPOA && (await validateNonIndividualAuthorisedSignatories(groups));
      application?.hasPOA &&
        (await validatePOAAuthorizedSignatories(
          application
          // toggler?.dateFeatureToggles?.poaValidationDate || ''
        ));
    }
    // await validateNonIndividualAuthorisedSignatories(groups);
    await validateNonIndividualUbo(
      applicants,
      ubo_declaration_type,
      ubo_declaration_value,
      ubos,
      nationalityDropdown,
      countryDropdown,
      createdAt
    );
  } catch (error) {
    if (error instanceof UboErrors) {
      throw (error as UboErrors).message;
    }
    if (error instanceof AuthorisedErrors) {
      throw (error as AuthorisedErrors).message;
    }
    if (error instanceof BankError) {
      throw (error as BankError).message;
    }
    throw `In ${error}, the required fields are not filled.`;
  }
};
export const acknowledgeApplication =
  ({ body, applicationId }: { body: Partial<ApplicationProps>; applicationId: string }) =>
  async (dispatch: any): Promise<ApplicationProps> => {
    return await dispatch({
      [CALL_API]: {
        url: `/onboarding/esign/${applicationId}/acknowledge`,
        method: 'POST',
        types: [UPDATE_APPLICATION_SUCCESS, UPDATE_APPLICATION],
        body,
      },
    });
  };
